import { Loader2 } from 'lucide-react';

import { WorkspaceExhibits } from '@/components/agent-chat-workspace/exhibits/WorkspaceExhibits';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { useGetSingletonWorkspaceQuery } from '@/services/api/agentChatWorkspaceService';

interface SetExhibitsModalProps {
  matterId: string;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export const SetExhibitsModal = ({
  matterId,
  open,
  onOpenChange,
}: SetExhibitsModalProps) => {
  const {
    data: workspace,
    isLoading,
    error,
  } = useGetSingletonWorkspaceQuery({ matterId }, { skip: !open || !matterId });

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-5xl w-[90vw] max-h-[85vh] overflow-hidden flex flex-col">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            Set Exhibits
          </DialogTitle>
          <DialogDescription>
            Select files to designate as exhibits for the demand letter. These
            will be prioritized during case context generation and included in
            the final demand package.
          </DialogDescription>
        </DialogHeader>

        <div className="flex-1 overflow-y-auto min-h-0">
          {!matterId ? (
            <div className="flex items-center justify-center h-48 text-muted-foreground">
              <p>Please select a matter first.</p>
            </div>
          ) : isLoading ? (
            <div className="flex items-center justify-center h-48">
              <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" />
            </div>
          ) : error ? (
            <div className="flex items-center justify-center h-48 text-destructive">
              <p>Failed to load workspace. Please try again.</p>
            </div>
          ) : workspace ? (
            <WorkspaceExhibits
              workspace={workspace}
              matterId={matterId}
              className="p-0"
            />
          ) : null}
        </div>

        <div className="flex justify-end pt-4 border-t">
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Done
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
